<template>
  <div class="work-item-detail-edit">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>作業項目</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="section">
      <validation-observer ref="obs" v-slot="ObserverProps">
        <div class="container">
          <dl class="columns">
            <dt>作業分類名</dt>
            <dd v-if="viewMode === 'e'">
              <ValidationProvider
                rules="workItemDetailEditSeasonRequired"
                immediate
                v-slot="ProviderProps"
              >
                <select
                  name="text"
                  oninput='this.style.height = "";'
                  v-model="editData.currentMenu"
                >
                  <option
                    v-for="(row, index) in menusDropDown"
                    :key="index"
                    :value="row"
                  >
                    {{ row.season_name }}
                  </option>
                </select>
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
            <dd v-if="viewMode === 'a'">
              <ValidationProvider
                rules="workItemDetailEditSeasonRequired"
                immediate
                v-slot="ProviderProps"
              >
                <select
                  name="text"
                  oninput='this.style.height = "";'
                  v-model="editData.currentMenu"
                  @change="onSeasonChange"
                >
                  <option
                    v-for="(row, index) in menusDropDown"
                    :key="index"
                    :value="row"
                  >
                    {{ row.season_name }}
                  </option>
                </select>
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>作業項目名</dt>
            <dd>
              <ValidationProvider
                rules="required|max:100"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="editData.itemData.item_name" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>作業区分</dt>
            <dd v-if="viewMode === 'e'">
              <label v-if="editData.itemData.is_not_paddy_field_item"
                >ほ場外作業</label
              >
              <label v-else>ほ場作業</label>
            </dd>
            <dd v-if="viewMode === 'a'">
              <template v-if="editData.currentMenu.season_id == null">
                <label></label>
              </template>
              <template v-else>
                <label v-if="editData.currentMenu.is_not_paddy_field_item"
                  >ほ場外作業</label
                >
                <label v-else>ほ場作業</label>
              </template>
            </dd>
          </dl>
          <dl class="columns">
            <dt>記録する内容</dt>
            <dd>
              <template v-if="!editData.currentMenu.is_not_paddy_field_item">
                <table class="stripe">
                  <tr>
                    <th style="width: 50%">項目</th>
                    <th>入力する内容</th>
                    <th>単位</th>
                    <th>自動計算</th>
                    <th class="sort" align="center" colspan="2">並び替え</th>
                  </tr>
                  <template v-for="(row, index) in menus">
                    <tr v-if="index === 0" :key="index">
                      <td>{{ row.item_detail_name }}</td>
                      <td>日付</td>
                      <td></td>
                      <td></td>
                      <td colspan="2"></td>
                    </tr>
                    <tr v-else-if="index === 1" :key="index">
                      <td>{{ row.item_detail_name }}</td>
                      <td>ユーザリスト</td>
                      <td></td>
                      <td></td>
                      <td colspan="2"></td>
                    </tr>
                    <tr v-else :key="index" style="cursor: pointer">
                      <td @click="showEditFrame(index)">
                        {{ row.item_detail_name }}
                      </td>
                      <td @click="showEditFrame(index)">
                        {{ displayTypeName(row.item_detail_type) }}
                      </td>
                      <td @click="showEditFrame(index)">
                        {{ row.item_detail_unit }}
                      </td>
                      <template v-if="row.item_detail_auto && !editData.currentMenu.is_not_paddy_field_item">
                        <td @click="showEditFrame(index)">
                          <span
                            class="check-on"
                          ></span>
                        </td>
                      </template>
                      <template v-else>
                        <td @click="showEditFrame(index)">
                        </td>
                      </template>
                      <td align="center" @click="onSortUp(index)">
                        <span
                          class="btn-sort-up"
                          :class="{
                            disable: index < 3,
                          }"
                        ></span>
                      </td>
                      <td align="center" @click="onSortDown(index)">
                        <span
                          class="btn-sort-down"
                          :class="{
                            disable: index === menus.length - 1,
                          }"
                        ></span>
                      </td>
                    </tr>
                  </template>
                  <template v-if="menus.length < 20">
                    <tr style="cursor: pointer" @click="showAddFrame">
                      <td colspan="6" align="center">
                        <span class="link-add">追加する</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="6" align="center">
                        <span class="link-add-disable">追加する</span>
                      </td>
                    </tr>
                  </template>
                </table>
              </template>
              <template v-else>
                <table class="stripe">
                  <tr>
                    <th style="width: 50%">項目</th>
                    <th>入力する内容</th>
                    <th>単位</th>
                    <th class="sort" align="center" colspan="2">並び替え</th>
                  </tr>
                  <template v-for="(row, index) in menus">
                    <tr v-if="index === 0" :key="index">
                      <td>{{ row.item_detail_name }}</td>
                      <td>日付</td>
                      <td></td>
                      <td colspan="2"></td>
                    </tr>
                    <tr v-else-if="index === 1" :key="index">
                      <td>{{ row.item_detail_name }}</td>
                      <td>ユーザリスト</td>
                      <td></td>
                      <td colspan="2"></td>
                    </tr>
                    <tr v-else :key="index" style="cursor: pointer">
                      <td @click="showEditFrame(index)">
                        {{ row.item_detail_name }}
                      </td>
                      <td @click="showEditFrame(index)">
                        {{ displayTypeName(row.item_detail_type) }}
                      </td>
                      <td @click="showEditFrame(index)">
                        {{ row.item_detail_unit }}
                      </td>
                      <td align="center" @click="onSortUp(index)">
                        <span
                          class="btn-sort-up"
                          :class="{
                            disable: index < 3,
                          }"
                        ></span>
                      </td>
                      <td align="center" @click="onSortDown(index)">
                        <span
                          class="btn-sort-down"
                          :class="{
                            disable: index === menus.length - 1,
                          }"
                        ></span>
                      </td>
                    </tr>
                  </template>
                  <template v-if="menus.length < 20">
                    <tr style="cursor: pointer" @click="showAddFrame">
                      <td colspan="5" align="center">
                        <span class="link-add">追加する</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="5" align="center">
                        <span class="link-add-disable">追加する</span>
                      </td>
                    </tr>
                  </template>
                </table>
              </template>

            </dd>
          </dl>
          <template
            v-if="
              editData.currentMenu.season_id != null &&
              !editData.currentMenu.is_not_paddy_field_item
            "
          >
            <dl class="columns">
              <dt>作業合計面積(a)</dt>
              <dd>
                <ValidationProvider
                  class="input-with-unit"
                  rules="customDoubleTwo"
                  v-slot="ProviderProps"
                >
                  <input
                    type="text"
                    v-model="editData.itemData.item_area_total"
                    style="max-width: 200px"
                  />
                  <div class="validation-error">
                    {{ ProviderProps.errors[0] }}
                  </div>
                </ValidationProvider>
              </dd>
            </dl>
            <dl class="columns">
              <dt>作業進捗</dt>
              <dd>
                <input
                  type="radio"
                  id="radio1"
                  name="progress"
                  value="1"
                  v-model="editData.itemData.item_progress"
                />
                <label for="radio1" class="label col3"
                  >ダッシュボードに表示する</label
                >
                <input
                  type="radio"
                  id="radio2"
                  name="progress"
                  value="2"
                  v-model="editData.itemData.item_progress"
                />
                <label for="radio2" class="label col2"
                  >ダッシュボードに表示しない</label
                >
              </dd>
            </dl>
            <dl class="columns">
              <dt>作業登録形式</dt>
              <dd>
                <input
                  type="radio"
                  id="radio2pt"
                  name="pattern"
                  value="2"
                  v-model="editData.itemData.item_pattern"
                />
                <label for="radio2pt" class="label col2"
                  >上書きする</label
                >
                <input
                  type="radio"
                  id="radio1pt"
                  name="pattern"
                  value="1"
                  v-model="editData.itemData.item_pattern"
                />
                <label for="radio1pt" class="label col3"
                  >追加登録する</label
                >
              </dd>
            </dl>
          </template>
          <template
            v-if="
              editData.currentMenu.season_id != null &&
              editData.currentMenu.is_not_paddy_field_item
            "
          >
            <dl class="columns">
              <dt>作業登録形式</dt>
              <dd>
                <input
                  type="radio"
                  id="radio2pt"
                  name="pattern"
                  value="2"
                  v-model="editData.itemData.item_pattern"
                />
                <label for="radio2pt" class="label col2"
                  >上書きする</label
                >
                <input
                  type="radio"
                  id="radio1pt"
                  name="pattern"
                  value="1"
                  v-model="editData.itemData.item_pattern"
                />
                <label for="radio1pt" class="label col3"
                  >追加登録する</label
                >
              </dd>
            </dl>
          </template>
        </div>
        <div id="button-area">
          <div class="left-box" />
          <div class="center-box">
            <span
              v-if="viewMode === 'e'"
              class="btn btn-submit"
              :class="{
                active: true,
                disable: ObserverProps.invalid || isReadOnly,
              }"
              @click="onSubmitWorkItemEdit"
              >保存</span
            >
            <span
              v-else
              class="btn btn-submit"
              :class="{
                active: true,
                disable: ObserverProps.invalid || isReadOnly,
              }"
              @click="onSubmitWorkItemAdd"
              >登録</span
            >
            <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
          </div>
          <div class="right-box">
            <span
              v-if="viewMode === 'e'"
              class="text"
              :class="{ 
                active: !isReadOnly,
                disabled: isReadOnly
              }"
              @click="onSubmitWorkItemDelete"
              >削除</span
            >
          </div>
        </div>
      </validation-observer>
    </div>
    <div
      v-if="!isCenterFrameHidden"
      class="center-frame-container"
    >
      <transition name="scale" appear>
        <div class="center-frame">
          <div class="title-area">
            <h3>項目追加</h3>
            <div class="btn-close" @click="hideCenterFrame"></div>
          </div>
          <validation-observer ref="obs" v-slot="ObserverProps">
            <section class="section">
              <div class="container">
                <div class="contents-body">
                  <dl class="columns">
                    <dt>項目名</dt>
                    <dd>
                      <ValidationProvider
                        rules="required|max:10"
                        v-slot="ProviderProps"
                      >
                        <input
                          type="text"
                          v-model="editForm.item_detail_name"
                        />
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dt>入力する内容</dt>
                    <dd>
                      <select
                        name="text"
                        oninput='this.style.height = "";'
                        v-model="editForm.item_detail_type"
                      >
                        <option
                          v-for="(row, index) in itemAttributes"
                          :key="index"
                          :value="row.type"
                        >
                          {{ row.name }}
                        </option>
                      </select>
                    </dd>
                    <template v-if="editForm.item_detail_type === 'num'">
                      <dt>単位</dt>
                      <dd>
                        <ValidationProvider
                          rules="max:10"
                          immediate
                          v-slot="ProviderProps"
                        >
                          <input
                            class="input"
                            type="text"
                            v-model="editForm.item_detail_unit"
                            maxlength="10"
                          />
                          <div
                            class="validation-error"
                            v-if="ProviderProps.invalid"
                          >
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                      </dd>
                    </template>
                    <template v-if="editForm.item_detail_type === 'num' && editData.currentMenu.season_id != null && !editData.currentMenu.is_not_paddy_field_item">
                      <dt>自動計算</dt>
                      <dd>
                        <input
                          id="item-auto1"
                          type="checkbox"
                          v-model="editForm.item_detail_auto"
                        />
                        <label for="item-auto1">ほ場面積10(a)あたりの量を自動計算する</label>
                        <div>
                          <span class="item-warn-message">※小数点第3桁を四捨五入します。</span>
                          <span class="item-warn-message">※ほ場面積が設定されていない場合は計算されません。</span>
                        </div>
                      </dd>
                    </template>
                  </dl>
                </div>
              </div>
            </section>
            <div id="button-area">
              <div class="left-box" />
              <div class="center-box">
                <span
                  v-if="isCenterFrameEdit"
                  class="btn btn-submit"
                  :class="{ disable: ObserverProps.invalid || isReadOnly }"
                  @click="onEditItem"
                  >保存</span
                >
                <span
                  v-else
                  class="btn btn-submit"
                  :class="{ disable: ObserverProps.invalid || isReadOnly }"
                  @click="onAddItem"
                  >追加</span
                >
                <span class="btn btn-cancel" @click="hideCenterFrame"
                  >キャンセル</span
                >
              </div>
              <div class="right-box">
                <span
                  v-if="isCenterFrameEdit"
                  class="text"
                  :class="{ active: !isReadOnly, disabled: isReadOnly }"
                  @click="onDeleteItem"
                  >削除</span
                >
              </div>
            </div>
          </validation-observer>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";

const CENTER_FRAME_STATUS = { HIDDEN: 0, ADD: 1, EDIT: 2 };
const PROGRESS_VALUE = { VISIBLE: "1", HIDDEN: "2" };
const PATTERN_VALUE = { ADD: "1", UPDATE: "2" };

export default {
  mixins: [Loader, Dialog],

  props: {
    viewMode: {
      type: String,
      default: "a",
    },
    season_id: Number,
    item_id: Number,
    routeName: {
      type: String,
      default: "works"
    }
  },

  data() {
    return {
      centerFrameStatus: CENTER_FRAME_STATUS.HIDDEN,
      isScrollable: false,
      maxHeight: 200,
      menusDropDown: [],
      requiredEditModeDate: false,
      requiredEditModeUser: false,
      itemAttributes: [
        { type: "string", name: "文字" },
        { type: "num", name: "数値" },
        { type: "date", name: "日付" },
        { type: "textarea", name: "フリー入力" },
      ],
      menus: [
        {
          key: "1",
          item_detail_id: null,
          item_detail_name: "実施日",
          item_detail_type: "date",
          item_detail_unit: null,
          item_detail_auto: null,
          display_flg: true,
        },
        {
          key: "2",
          item_detail_id: null,
          item_detail_name: "作業者",
          item_detail_type: "list",
          item_detail_unit: null,
          item_detail_auto: null,
          item_detail_key: "users",
        },
      ],
      editData: {
        currentMenu: {
          season_id: null,
          season_name: "選択してください",
          is_not_paddy_field_item: false,
        },
        itemData: {
          season_id: null,
          item_id: null,
          item_name: null,
          is_not_paddy_field_item: false,
          item_details: [],
          item_area_total: null,
          item_progress: PROGRESS_VALUE.VISIBLE,
          item_pattern: null,
        },
      },
      editForm: {
        item_detail_id: null,
        item_detail_name: null,
        item_detail_type: "string",
        item_detail_unit: null,
        item_detail_auto: null,
      },
      editFormIndex: null,
      isReadOnly: false,
    };
  },
  computed: {
    isCenterFrameHidden() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.HIDDEN;
    },

    isCenterFrameEdit() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.EDIT;
    },
  },

  mounted: function () {
    // プルダウン情報
    const mstSeasons = this.getSeasons();
    this.menusDropDown = [];
    this.isReadOnly = this.isPastManagement();
    if (this.viewMode === "e") {
      // 編集データ抽出
      var wkItem = mstSeasons.filter(function (value) {
        return value.season_id === this;
      }, this.season_id);
      var wkDetailItem = wkItem[0].items.filter(function (value) {
        return value.item_id === this;
      }, this.item_id);

      // ほ場内、ほ場外それぞれに合わせ作業分類を抽出する
      mstSeasons.forEach(seasonItem => {
        if (wkDetailItem[0].is_not_paddy_field_item) {
          if (seasonItem.is_not_paddy_field_item) {
            this.menusDropDown.push({
              season_id: seasonItem.season_id,
              season_name: seasonItem.season_name,
              is_not_paddy_field_item: seasonItem.is_not_paddy_field_item,
            });
          }
        }
        else {
          if (!seasonItem.is_not_paddy_field_item) {
            this.menusDropDown.push({
              season_id: seasonItem.season_id,
              season_name: seasonItem.season_name,
              is_not_paddy_field_item: seasonItem.is_not_paddy_field_item,
            });
          }
        }
      });
      this.menusDropDown.unshift({
        season_id: null,
        season_name: "選択してください",
        is_not_paddy_field_item: wkDetailItem[0].is_not_paddy_field_item,
      });

      this.editData.itemData.item_id = wkDetailItem[0].item_id;
      this.editData.itemData.item_name = wkDetailItem[0].item_name;
      this.editData.itemData.is_not_paddy_field_item =
        wkDetailItem[0].is_not_paddy_field_item;

      this.editData.itemData.item_area_total = wkDetailItem[0].item_area_total;
      this.editData.itemData.item_progress = wkDetailItem[0].item_progress;
      if (this.editData.itemData.item_progress !== PROGRESS_VALUE.HIDDEN) {
        // nullもありえるため
        this.editData.itemData.item_progress = PROGRESS_VALUE.VISIBLE;
      }
      this.editData.itemData.item_pattern = wkDetailItem[0].item_pattern;
      if (!this.editData.itemData.item_pattern) {
        // ほ場外作業かどうかで初期値を設定する
        if (this.editData.itemData.is_not_paddy_field_item) {
          this.editData.itemData.item_pattern = PATTERN_VALUE.ADD;
        }
        else {
          this.editData.itemData.item_pattern = PATTERN_VALUE.UPDATE;
        }
      }

      // 実績項目を更新する
      for (let i = 0; i < wkDetailItem[0].item_details.length; i++) {
        let detailItem = wkDetailItem[0].item_details[i];
        if (this.menus.length < i) {
          this.menus.push(detailItem);
        } else {
          this.menus[i] = detailItem;
        }
      }

      // 作業分類
      var selectedSeason = this.menusDropDown.find(function (value) {
        return value.season_id === this;
      }, this.season_id);

      if (selectedSeason) {
        this.editData.currentMenu = selectedSeason;
      }
      else {
        this.editData.currentMenu = this.menusDropDown[0];
      }
    }
    else {
      mstSeasons.forEach(seasonItem => {
        this.menusDropDown.push({
          season_id: seasonItem.season_id,
          season_name: seasonItem.season_name,
          is_not_paddy_field_item: seasonItem.is_not_paddy_field_item,
        });
      });
      this.menusDropDown.unshift({
        season_id: null,
        season_name: "選択してください",
        is_not_paddy_field_item: false,
      });
    }
  },

  methods: {
    ...mapGetters(["getSeasons", "isPastManagement"]),
    ...mapActions(["insertItems", "updateItems", "deleteItems"]),

    async onSubmitWorkItemAdd() {
      this.loading(async () => {
        this.editData.itemData.season_id = this.editData.currentMenu.season_id;
        this.editData.itemData.is_not_paddy_field_item =
          this.editData.currentMenu.is_not_paddy_field_item;
        this.editData.itemData.item_details = [];
        // todo:id 設定
        this.menus.forEach((item) => {
          if (item.item_detail_name) {
            this.editData.itemData.item_details.push(item);
          }
        });

        // 田圃外作業の場合、クリアする
        if (this.editData.itemData.is_not_paddy_field_item) {
          this.editData.itemData.item_progress = null;
          this.editData.itemData.item_area_total = null;
          // ほ場外作業の場合、自動計算フラグを落とす（追加途中で大分類が変更される可能性があるためここでクリア処理を入れる）
          for (const detail of this.editData.itemData.item_details) {
            detail.item_detail_auto = null;
          }
        }

        try {
          await this.insertItems(this.editData.itemData);
        } catch (err) {
          console.log(err);
        }
        this.$router.push({ name: this.routeName });
      });
    },
    async onSubmitWorkItemEdit() {
      this.loading(async () => {
        this.editData.itemData.item_details = [];
        // todo:id 設定
        this.menus.forEach((item) => {
          if (item.item_detail_name) {
            this.editData.itemData.item_details.push(item);
          }
        });

        // 作業分類ID更新
        this.editData.itemData.season_id = this.editData.currentMenu.season_id;

        try {
          await this.updateItems(this.editData.itemData);
        } catch (err) {
          console.log(err);
        }
        this.$router.push({ name: this.routeName });
      });
    },
    async onSubmitWorkItemDelete() {
      this.showConfirm("削除しますか？", async () => {
        this.loading(async () => {
          await this.deleteItems(this.editData.itemData.item_id);
          this.$router.push({ name: this.routeName });
        });
      });
    },
    WorkItemDelete: function (index) {
      for (let i = index + 1; i < this.menus.length; i++) {
        this.menus[i - 1].item_detail_id = this.menus[i].item_detail_id;
        this.menus[i - 1].item_detail_name = this.menus[i].item_detail_name;
        this.menus[i - 1].item_detail_type = this.menus[i].item_detail_type;
        this.menus[i - 1].item_detail_unit = this.menus[i].item_detail_unit;
        this.menus[i - 1].item_detail_auto = this.menus[i].item_detail_auto;
      }
      this.menus[this.menus.length - 1].item_detail_id = null;
      this.menus[this.menus.length - 1].item_detail_name = null;
      this.menus[this.menus.length - 1].item_detail_type = "string";
      this.menus[this.menus.length - 1].item_detail_unit = null;
      this.menus[this.menus.length - 1].item_detail_auto = null;
    },
    changeModeDate() {
      this.requiredEditModeDate = true;
    },
    changeModeUser() {
      this.requiredEditModeUser = true;
    },
    onCancel: function () {
      this.$router.push({ name: this.routeName });
    },

    displayTypeName(itemType) {
      if (itemType) {
        const itemVal = this.itemAttributes.filter((e) => e.type === itemType);
        if (itemVal && itemVal.length > 0) {
          return itemVal[0].name;
        }
      }
      return null;
    },
    showAddFrame() {
      this.editForm = {
        item_detail_id: null,
        item_detail_name: null,
        item_detail_type: "string",
        item_detail_unit: null,
        item_detail_auto: null,
      };
      this.editFormIndex = null;
      this.centerFrameStatus = CENTER_FRAME_STATUS.ADD;
    },
    showEditFrame(index) {
      this.editForm = {
        item_detail_id: this.menus[index].item_detail_id,
        item_detail_name: this.menus[index].item_detail_name,
        item_detail_type: this.menus[index].item_detail_type,
        item_detail_unit: this.menus[index].item_detail_unit,
        item_detail_auto: this.menus[index].item_detail_auto,
      };
      this.editFormIndex = index;
      this.centerFrameStatus = CENTER_FRAME_STATUS.EDIT;
    },
    onAddItem() {
      if (this.editForm.item_detail_type !== "num") {
        this.editForm.item_detail_auto = null;
        this.editForm.item_detail_unit = null;
      }

      this.menus.push(this.editForm);
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
    },
    onEditItem() {
      if (this.editForm.item_detail_type !== "num") {
        this.editForm.item_detail_auto = null;
        this.editForm.item_detail_unit = null;
      }
      const _tmp = {
        item_detail_id: this.editForm.item_detail_id,
        item_detail_name: this.editForm.item_detail_name,
        item_detail_type: this.editForm.item_detail_type,
        item_detail_unit: this.editForm.item_detail_unit,
        item_detail_auto: this.editForm.item_detail_auto,
      };
      this.$set(this.menus, this.editFormIndex, _tmp);
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
    },
    onDeleteItem() {
      this.menus = this.menus.filter(
        (el, index) => index != this.editFormIndex
      );
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
    },
    onSortUp(index) {
      if (index < 3) {
        return;
      }

      const tmp1 = this.menus[index];
      const tmp2 = this.menus[index - 1];
      this.$set(this.menus, index - 1, tmp1);
      this.$set(this.menus, index, tmp2);
    },
    onSortDown(index) {
      if (index < 2 || index > this.menus.length - 2) {
        return;
      }

      const tmp1 = this.menus[index];
      const tmp2 = this.menus[index + 1];
      this.$set(this.menus, index, tmp2);
      this.$set(this.menus, index + 1, tmp1);
    },
    hideCenterFrame() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
    },

    onSeasonChange() {
      if (this.editData.currentMenu.season_id) {
        // ほ場外作業が選択された場合
        if (this.editData.currentMenu.is_not_paddy_field_item) {
          this.editData.itemData.item_pattern = PATTERN_VALUE.ADD;
        }
        else {
          this.editData.itemData.item_pattern = PATTERN_VALUE.UPDATE;
        }
      }
    }
  },
};
</script>

<style lang="scss">
.work-item-detail-edit {
  .section {
    overflow: auto;
    width: 90%;
    // height: calc(100% - 130px);
    height: 100%;
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      /* フォーム */

      input[type="text"],
      input[type="date"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
        white-space:nowrap;
        width:100%;
        overflow:hidden;
        text-overflow:ellipsis;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }

      .item-warn-message {
        display: block;
        font-size: 0.8rem;
        color: red;
      }
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.sort {
      width: 10%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }
  #edit-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  #edit-area span {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
    cursor: pointer;
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 0px auto 40px;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text.disabled {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  .link-add {
    font-size: 14px;
    text-align: center;
    color: var(--purple);
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: pointer;
  }
  .link-add::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_add_active.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 5px;
  }
  .link-add-disable {
    font-size: 14px;
    text-align: center;
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: inherit;
    pointer-events: none;
  }
  .link-add-disable::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_add_disabled.svg") no-repeat center
      center;
    background-size: 20px 20px;
    padding: 0 0 0 5px;
  }
  .btn-close {
    cursor: pointer;
    width: 32px;
    height: 32px;
    background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
    background-size: contain;
  }
  .btn-sort-up {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--purple) url("~@/assets/icons/ic_arrow_up.svg") no-repeat
      center center;
    margin: 5px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  .btn-sort-down {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--purple) url("~@/assets/icons/ic_arrow_down.svg") no-repeat
      center center;
    margin: 5px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  .check-on {
    display: block;
    width: 25px;
    height: 25px;
    background: url("~@/assets/icons/ic_check_on.svg") no-repeat
      center center;
    margin: auto;
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_style.svg") no-repeat center center;
  }

  .center-frame-container {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      max-height: 80vh;
      overflow-y: scroll;
      position: fixed;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    .title-area {
      width: 100%;
      // height: 80px;
      min-height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }
  }
}
</style>
